import { render, staticRenderFns } from "./ClassSummary.vue?vue&type=template&id=2f737200&scoped=true&"
import script from "./ClassSummary.vue?vue&type=script&lang=js&"
export * from "./ClassSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClassSummary.vue?vue&type=style&index=0&id=2f737200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f737200",
  null
  
)

export default component.exports